<template>
  <div class="contents userMgt">
    <div class="title flexB">
      <h2>리뷰 관리</h2>
    </div>
    <div class="box one filter">
      <div class="flex">
        <p class="bold">검색조건</p>
        <select v-model="inputMode">
          <option value="comment">내용</option>
        </select>
        <input type="text" v-model="searchWord" @keyup.enter="search" />
      </div>
      <div class="flex">
        <p class="bold">카테고리</p>
        <label>
          <input type="radio" value="" checked v-model="category" />전체
        </label>
        <label>
          <input type="radio" value="weddingPlace" v-model="category" />
          웨딩 장소
        </label>
        <label>
          <input type="radio" value="collection" v-model="category" />
          웨딩 컬렉션
        </label>
        <label>
          <input type="radio" value="planner" v-model="category" />
          플래너
        </label>
        <label>
          <input type="radio" value="store" v-model="category" />
          스토어
        </label>
      </div>
      <div class="buttonWrap">
        <button class="basic" @click="search">검색</button>
        <button class="line" @click="reset">초기화</button>
      </div>
    </div>

    <div class="box one">
      <h2 class="bold">리뷰 리스트</h2>
      <table>
        <colgroup>
          <col style="width: 10%" />
          <col style="width: 15%" />
          <col style="width: 50%" />
          <col style="width: 10%" />
          <col style="width: 15%" />
        </colgroup>
        <tr>
          <th>번호</th>
          <th>카테고리</th>
          <th>내용</th>
          <th>작성자</th>
          <th>등록일</th>
        </tr>
        <tr v-for="(data, i) in reviewList" :key="i">
          <td>{{ total + 1 - (i + 1 + (currentPage - 1) * 10) }}</td>
          <td>
            {{
              data.category == "weddingPlace"
                ? "웨딩 장소"
                : data.category == "collection"
                ? "웨딩 컬렉션"
                : data.category == "planner"
                ? "플래너"
                : data.category == "store"
                ? "스토어"
                : ""
            }}
          </td>
          <td class="left">
            <router-link to @click.native="handleMove(data._id)">{{
              data.comment
            }}</router-link>
          </td>
          <td>{{ data.author ? data.author.username : "" }}</td>
          <td>{{ moment(data.createdAt).format("YYYY.MM.DD HH:mm") }}</td>
        </tr>
      </table>
      <NoData v-if="isNodata" />
      <div class="pagination" v-if="reviewList.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { fetchReview } from "@/api/admin";
import NoData from "@/components/contents/Nodata";
import { format } from "@/mixins/format";
export default {
  mixins: [format],
  components: { NoData },
  data() {
    return {
      moment: moment,
      category: "",
      reviewList: [],
      inputMode: "comment",
      searchWord: "",
      total: 0,
      currentPage: 1,
      isNodata: false,
    };
  },
  computed: {
    ...mapState(["navbarState"]),
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", "11");
  },
  mounted() {
    this.getReviewList();
  },
  methods: {
    reset() {
      this.inputMode = "comment";
      this.searchWord = "";
      this.category = "";
      this.currentPage = 1;
      this.reviewList = [];
      this.total = 0;
      this.getReviewList();
    },
    search() {
      if (this.searchWord && this.inputMode == "") {
        this.$alert("검색 조건을 선택해 주세요.", {
          confirmButtonText: "확인",
          center: true,
        });
        return;
      }
      this.getReviewList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getReviewList();
    },
    handleMove(id) {
      this.$router.push({ name: "reviewdetail", query: { id: id } });
    },
    getReviewList() {
      let params = {
        page: this.currentPage,
        searchWord: this.searchWord,
        inputMode: this.inputMode,
        category: this.category,
      };
      fetchReview(params).then((res) => {
        if (res.data.status == 200) {
          this.reviewList = res.data.data;
          this.total = res.data.total;
          this.isNodata = this.total == 0 ? true : false;
        } else {
          this.$alert(res.data.message, {
            confirmButtonText: "확인",
            center: true,
          });
        }
      });
    },
  },
};
</script>
